<template>
  <img class="image" :src="image" ref="image"/>
</template>

<script>
import Croppie from 'croppie';
import 'croppie/croppie.css';

export default {
  name: 'Croppie',
  components: {
    Croppie,
  },
  data() {
    return {
      croppie: null,
    };
  },
  props: {
    image: {
      type: String,
      required: true,
    },
    opts: {
      default: {},
    },
  },
  mounted() {
    this.croppie = new Croppie(this.$refs.image, this.opts);
  },
  methods: {
    async upload(params) {
      if (!this.croppie) {
        return null;
      }
      return this.croppie.result(params);
    },
  },
};
</script>

<style lang="scss">
.image {

}
</style>
